import { Alert, Box, Button, CircularProgress, InputAdornment, Link, TextField } from "@mui/material";
import SearchIcon from '@mui/icons-material/Search';
import { useState } from "react";
import { useQuery } from "react-query";
import axiosClient from "../../../../../../lib/axios";
import { TFormState } from ".";

export default function Step01({
    form,
    handleNext,
    handleUpdateForm,
    handleChangeProcesso
}: Step01Props) {

    const [numRecibo, setNumRecibo] = useState(form.numRecibo)
    const [processoEncontrado, setProcessoEncontrado] = useState<boolean | string>();
    const [codigoProcesso, setCodigoProcesso] = useState<string | null>(null)


    //querys e mutations
    const { isLoading: loadingData, refetch } = useQuery({
        queryKey: ['financeiro/contas-receber/detalhar-recibo', numRecibo],
        queryFn: () => axiosClient.get("/financeiro/contas-receber/detalhar-recibo/" + numRecibo),
        enabled: false,
        cacheTime: 0,
        retry: false,
        onError: (error) => {
            setProcessoEncontrado(false);
        },
        onSuccess: ({ data }) => {
            setProcessoEncontrado(data.processo_cancelamento_em_execucao);
            if (!data.processo_cancelamento_em_execucao) {
                handleUpdateForm({
                    numRecibo,
                    titulosRelacionados: data.movimentacoes
                })
                handleNext()
            }
            if (data.processo_cancelamento_em_execucao && data.codigo_processo) {
                setCodigoProcesso(data.codigo_processo)
            }
        }
    });

    const handleOpenProcesso = () => {
        if (codigoProcesso) {
            handleChangeProcesso(codigoProcesso)
        }
    }

    const handleProccessQuery = () => {
        refetch();
    };

    return (
        <>
            {
                !loadingData && processoEncontrado &&
                <Box mt={2} mb={3}>
                    <Alert severity="warning" variant="outlined">
                        O recibo selecionado possui um processo de cancelamento em execução. <Link onClick={() => handleOpenProcesso()} sx={{ cursor: 'pointer' }}>Clique aqui</Link> para abrir o processo.
                    </Alert>
                </Box>
            }
            <TextField
                variant="outlined"
                label="Nº do recibo"
                type="number"
                value={numRecibo === 0 ? null : numRecibo}
                onChange={({ target }) => setNumRecibo((Number(target.value)))}
                slotProps={{
                    input: {
                        endAdornment:
                            <InputAdornment position="end">
                                <SearchIcon />
                            </InputAdornment>
                    }
                }}
            />

            <Box sx={{ mt: 2 }}>
                <Button
                    variant="contained"
                    onClick={handleProccessQuery}
                    sx={{ mt: 1, mr: 1 }}
                    disabled={loadingData}
                >
                    {loadingData ? 'Carregando...' : 'Avançar'}
                </Button>
                {
                    loadingData &&
                    <Box display="flex" justifyContent="center" my={4}>
                        <CircularProgress />
                    </Box>
                }
            </Box>
        </>
    )
}

interface Step01Props {
    form: TFormState,
    handleChangeProcesso: (item: string) => void
    handleNext: () => void,
    handleUpdateForm: (value: TFormState) => void
}